import React from 'react';
import PropTypes from 'prop-types';

const TopHeaderMenuContainer = ({ children, name, backgroundColor }) => (
  <div id={name} className={`w-full bg-${backgroundColor}`}>
    { children }
  </div>
);

TopHeaderMenuContainer.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.shape().isRequired,
  backgroundColor: PropTypes.string,
};

TopHeaderMenuContainer.defaultProps = {
  backgroundColor: 'white',
};

export default TopHeaderMenuContainer;
